import { Leaf } from "lucide-react";
import { useT } from "../../lib/i18n";

const dayIndex = (start, end) => {
  const ms = 86400000;
  const today = new Date(); today.setHours(12, 0, 0, 0);
  const s = new Date(start + "T12:00:00"), e = new Date(end + "T12:00:00");
  const total = Math.round((e - s) / ms) + 1;
  const day = Math.round((today - s) / ms) + 1;
  return { day, total };
};

// Slim strip under the greeting for retreat guests: "Escape to the Mountains · Day 3 of 11 · with Luke"
const RetreatBanner = ({ retreat }) => {
  const { t } = useT();
  if (!retreat?.start) return null;
  const { day, total } = dayIndex(retreat.start, retreat.end);
  const status = day < 1
    ? `${t("starts in")} ${1 - day} ${t(1 - day === 1 ? "day" : "days")}`
    : day > total ? t("wrapped — thank you") : `${t("Day")} ${day} ${t("of")} ${total}`;
  const host = (retreat.host || "").split(" ")[0];
  return (
    <div className="flex items-start gap-3 bg-[#8C9A7C]/12 border border-[#8C9A7C]/30 rounded-xl px-4 py-3" data-testid="retreat-banner">
      <Leaf className="w-4 h-4 text-[#5C6A4C] flex-shrink-0 mt-0.5" />
      <p className="text-sm text-[#1A1A1A] min-w-0 leading-snug">
        <span className="font-semibold">{retreat.name}</span>
        <span className="hidden sm:inline text-[#1A1A1A]/55"> · </span>
        <span className="block sm:inline text-[13px] sm:text-sm text-[#1A1A1A]/55">{status}{host ? ` · ${t("with")} ${host}` : ""}</span>
      </p>
    </div>
  );
};

export default RetreatBanner;
